import { useState, useEffect } from "react";
// --------------------- Import Services ---------------------

import { buscarCotasUsuario } from "../../../services/buscarCotasUsuario";

// --------------------- Import Interfaces ---------------------

export const useCotas = () => {
  const [cotas, setCotas] = useState<[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetch = async () => {
      const data = await buscarCotasUsuario();

      setCotas(data);
      setIsLoading(false);
    };

    fetch();
  }, []);

  return { cotas, isLoading };
};
